import Button from 'ui-kit/components/button';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const CancelButton = setComponentTemplate(precompileTemplate("\n  <Button class=\"fluid form-button\" type=\"button\" onclick={{@onClick}} disabled={{@disabled}} data-test-cancel-button>\n    {{if @title @title \"Retour\"}}\n  </Button>\n", {
  strictMode: true,
  scope: () => ({
    Button
  })
}), templateOnly(undefined, "cancel-button:CancelButton"));
export default CancelButton;